import styled from "styled-components";
import { AiOutlineMenu } from "react-icons/ai";
import { NavLink as Link } from "react-router-dom";
import breakpoint from "../../assets/breakpoints";
import { Avatar } from "react-rainbow-components";
interface INavLink {
  showsidebar: string;
  isselected: string;
}

interface ISideBarProps {
  showsidebar: string;
}

export const SideBar = styled.div`
  z-index: 999;
  height: 100vh;
  width: ${(props: ISideBarProps) =>
    props.showsidebar === "true" ? "240px" : "78px"};
  top: 0;
  left: 0;
  bottom: 0;
  background: #11101d;
  display: flex;
  flex-direction: column;
  transition: all 0.5s ease;
  position: fixed;
  @media only screen and ${breakpoint.device.sm} {
    width: ${(props: ISideBarProps) =>
      props.showsidebar === "true" ? "100vw" : "0px"};
    overflow: hidden;
  }

  ul {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 14px;
  }
  ul li {
    position: relative;
    height: 50px;
    width: 100%;
    margin: 8px 0;
    list-style: none;
    line-height: 50px;
  }
  ul li .tooltip {
    position: absolute;
    left: 122px;
    top: 0;
    transform: translate(-50%, -50%);
    border-radius: 6px;
    height: 35px;
    width: 122px;
    background-color: #fff;
    line-height: 35px;
    text-align: center;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    transition: 0s;
    pointer-events: none;
    font-family: Kanit;

    display: ${(props: ISideBarProps) =>
      props.showsidebar === "true" ? "none" : "block"};
  }
  ul li:hover .tooltip {
    transition: all 0.5s ease;
    opacity: 1;
    top: 50%;
  }
`;

export const NavLink = styled(Link)`
  color: #fff;
  display: flex;
  align-items: center;
  text-decoration: none;
  border-radius: 12px;
  transition: all 0.4s ease;
  white-space: nowrap;
  ${(props: INavLink) =>
    props.isselected === "true" && "color: #11101d; background-color: #fff;"}
  width: ${(props: INavLink) =>
    props.showsidebar === "true" ? "100%" : "50px"};

  &:hover {
    color: #11101d;
    background-color: #fff;
  }
`;

export const LogoDiv = styled.div`
  height: 50px;
  border-radius: 12px;
  line-height: 50px;
  min-width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const Menu = styled(AiOutlineMenu)`
  position: absolute;
  color: #fff;
  left: ${(props: ISideBarProps) =>
    props.showsidebar === "true" ? "90%" : "50%"};
  top: 6px;
  text-align: center;
  line-height: 50px;
  transform: translateX(-50%) translateY(80%);
  cursor: pointer;
`;

export const NavList = styled.div`
  margin-top: 20px;
  height: 100%;
`;
export const LinkName = styled.span`
  opacity: ${(props: ISideBarProps) =>
    props.showsidebar === "true" ? "1" : "0"};
  pointer-events: none;
`;

export const ProfileContent = styled.div`
  color: #fff;
  bottom: 0;
  left: 0;
  width: 100%;
  transform: translateY(-20%);
  min-height: 2rem;
  margin-top: auto;
  .profile {
    position: relative;
    height: 60px;
    background-color: #1d1b31;
    text-align: start;
    display: flex;
    padding-left: 0.5rem;
    align-items: center;
    .profile_details {
      display: flex;
      align-items: center;
      opacity: ${(props: ISideBarProps) =>
        props.showsidebar === "true" ? "1" : "0"};
      pointer-events: ${(props: ISideBarProps) =>
        props.showsidebar === "true" ? "auto" : "none"};
      white-space: nowrap;
      .name_role {
        margin-left: 10px;
        .name {
          font-size: 15px;
          font-weight: 400;
          width: calc(15px * 8);
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .role {
          font-size: 12px;
        }
      }
    }
    .logout {
      position: absolute;
      left: ${(props: ISideBarProps) =>
        props.showsidebar === "true" ? "88%" : "50%"};
      bottom: 0.5rem;
      transform: translateX(-50%) translateY(10%);
    }
  }
`;

export const ImageProfile = styled(Avatar)`
  border-radius: 12px;
`;

export const PointNotify = styled.div`
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 1rem;
  background-color: red;
  position: absolute;
  bottom: 1rem;
  right: 1rem;
`;

export const BubbleMenu = styled.div`
  position: absolute;
  top: 0rem;
  left: 0rem;
  padding: 0.5rem;
  width: 56px;
  height: 56px;
  z-index: 999;
`;
